export default "__VITE_ASSET__DsryVEqB__"